<div class="page-title-area">
    <div class="container">
      <div class="page-title-content">
        <h2>Artificial Intellegence</h2>
        <ul>
          <li><a routerLink="/services">Services</a></li>
          <li>Artificial Intellegence</li>
        </ul>
      </div>
    </div>
  </div>